import React, { Fragment } from 'react'
import LineItemInput from './LineItemInput'
import { Box, Divider, Grid } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-regular-svg-icons'
import { useTranslation } from 'react-i18next'
import ElementContainer from '../../ElementContainer'
import SwipeableComponent from './SwipeableComponent'

import { singleLineItemStyles } from '../../../../styles/classes/MobilePreviewClasses'
import DropDownSelection from '../DropDownSelection'
import { lineItemFields, rateTypeOptions } from '../../../../lib/Constants'

const SingleLineItem = ({
  item,
  index,
  onChange,
  onRemove,
  disabled,
  helpfulHint,
  isMandatory,
  itemSettings,
  rateOptions,
  updateCallback
}) => {
  const { t } = useTranslation()
  const { classes } = singleLineItemStyles()
  const enableRate = itemSettings?.rate !== rateTypeOptions.DISABLE
  const enableLaborType = itemSettings?.labor_type
  const enableDescription = itemSettings?.description
  const enableTax = itemSettings?.tax
  const lineItemsOptions = itemSettings?.labor_type_options ?? []
  let lineItemAnswer = []
  if (item.labor_type) {
    const liIndex = lineItemsOptions.indexOf(item.labor_type)
    if (liIndex !== -1) {
      lineItemAnswer = lineItemsOptions.map((_, index) => {
        if (index === liIndex) return true
        else return false
      })
    }
  }

  let rateAnswer = []
  if (item.rate) {
    const rateIndex = rateOptions.indexOf(item.rate)
    if (rateIndex !== -1) {
      rateAnswer = rateOptions.map((_, index) => {
        if (index === rateIndex) return true
        else return false
      })
    }
  }

  const RightButton = () => {
    return (
      <div className={classes.deleteButton} onClick={() => onRemove(index)}>
        <FontAwesomeIcon className={classes.icon} icon={faTrash} />
      </div>
    )
  }

  function handleLineItemChange (updatedArray, index) {
    const lineItemOptionIndex = updatedArray.findIndex(item => item === true)
    if (index !== -1) {
      onChange(
        index,
        lineItemFields.LABOR_TYPE,
        lineItemsOptions[lineItemOptionIndex]
      )
    }
  }

  function handleRateChange (updatedArray, index) {
    const rateOptionIndex = updatedArray.findIndex(item => item === true)
    if (index !== -1) {
      onChange(index, lineItemFields.RATE, rateOptions[rateOptionIndex])
    }
  }
  return (
    <SwipeableComponent rightButton={<RightButton />}>
      <ElementContainer
         title={`${t('mobile_preview.line_item.line_item')} ${index + 1}`}
         helpfulHint={helpfulHint}
         isMandatory={isMandatory}
      >
        {enableLaborType && (
          <DropDownSelection
            title={t('mobile_preview.line_item.labor_type', {
              number: index + 1
            })}
            helpfulHint={helpfulHint}
            multiCheck={false}
            itemOptions={lineItemsOptions}
            onChangeValue={updatedArray => {
              handleLineItemChange(updatedArray, index)
            }}
            answer={lineItemAnswer}
            isMandatory={isMandatory}
          />
        )}
        {enableRate && (
          <Fragment>
            <Box sx={{ height: 10 }} />
            <DropDownSelection
              fromLineItem
              title={t('mobile_preview.line_item.rate')}
              helpfulHint={null}
              multiCheck={false}
              itemOptions={rateOptions}
              onChangeValue={updatedArray => {
                handleRateChange(updatedArray, index)
              }}
              answer={rateAnswer}
              isMandatory={isMandatory}
            />
          </Fragment>
        )}
        <Box sx={{ height: 10 }} />
        {enableDescription && (
          <LineItemInput
            onBlur={updateCallback}
            disabled={disabled}
            placeholder={`${t('mobile_preview.line_item.enter')} ${t(
              'mobile_preview.line_item.description'
            )}`}
            label={`${t('mobile_preview.line_item.additinal_description')}`}
            onChange={e =>
              onChange(index, lineItemFields.DESCRIPTION, e.target.value)
            }
            value={item.description}
          />
        )}
        {!enableTax && (
          <Grid container>
            <Grid item xs className={classes.rowItem}>
              <LineItemInput
                onBlur={updateCallback}
                disabled={disabled}
                placeholder={'$000.00'}
                label={`${t('mobile_preview.line_item.amount')} #`}
                onChange={e =>
                  onChange(index, lineItemFields.AMOUNT, e.target.value)
                }
                value={item.amount}
              />
            </Grid>
            <Divider
              orientation="vertical"
              flexItem
              className={classes.dividerStyle}
            />
            <Grid item xs className={classes.rowItem}>
              <LineItemInput
                onBlur={updateCallback}
                disabled={disabled}
                placeholder={'00'}
                label={t('mobile_preview.line_item.qty')}
                onChange={e =>
                  onChange(index, lineItemFields.QUANTITY, e.target.value)
                }
                value={item?.quantity}
              />
            </Grid>
            <Divider
              orientation="vertical"
              flexItem
              className={classes.dividerStyle}
            />
            <Grid item xs className={classes.rowItem}>
              <LineItemInput
                onBlur={updateCallback}
                disabled={true} // always disabled
                placeholder={'$000.00'}
                label={t('mobile_preview.line_item.total_amount')}
                onChange={e =>
                  onChange(index, lineItemFields.TOTAL, e.target.value)
                }
                value={item?.total}
              />
            </Grid>
          </Grid>
        )}

        {enableTax && (
          <Grid container columns={{ xs: 4, sm: 8, md: 12 }}>
            <Grid item xs={4} md={6} className={classes.rowItem}>
              <LineItemInput
                onBlur={updateCallback}
                disabled={disabled}
                placeholder={'$000.00'}
                label={`${t('mobile_preview.line_item.amount')} #`}
                onChange={e =>
                  onChange(index, lineItemFields.AMOUNT, e.target.value)
                }
                value={item.amount}
              />
            </Grid>
            <Grid item xs={4} md={6} className={classes.rowItem}>
              <Divider
                orientation="vertical"
                flexItem
                className={classes.dividerStyle}
              />
              <LineItemInput
                onBlur={updateCallback}
                disabled={disabled}
                placeholder={'00'}
                label={t('mobile_preview.line_item.qty')}
                onChange={e =>
                  onChange(index, lineItemFields.QUANTITY, e.target.value)
                }
                value={item?.quantity}
              />
            </Grid>
            <Grid item xs={4} md={6} className={classes.rowItem}>
              <LineItemInput
                onBlur={updateCallback}
                disabled={disabled}
                placeholder={'00.00%'}
                label={`${t('mobile_preview.line_item.tax')} (%)`}
                onChange={e =>
                  onChange(index, lineItemFields.TAX, e.target.value)
                }
                value={item?.tax}
              />
            </Grid>
            <Grid item xs={4} md={6} className={classes.rowItem}>
              <Divider
                orientation="vertical"
                flexItem
                className={classes.dividerStyle}
              />
              <LineItemInput
                onBlur={updateCallback}
                disabled={true} // always disabled
                placeholder={'$000.00'}
                label={t('mobile_preview.line_item.total_price')}
                onChange={e =>
                  onChange(index, lineItemFields.TOTAL, e.target.value)
                }
                value={item?.total}
              />
            </Grid>
          </Grid>
        )}
      </ElementContainer>
    </SwipeableComponent>
  )
}

export default SingleLineItem
